<template>
    <van-button block color="#f0d48f">
        <slot>按钮</slot>
    </van-button>
</template>

<script>
    export default {
        name: 'DefaultBtn'
    }
</script>